import { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootReduxState } from "../../../../../utils/types";
import { checkStatusAction } from "../../redux/auth/actions";
import { updateIntegrationAction } from "../../redux/shopData/actions";

type OAuthWindowComponentOwnProps = {
  selectedShop: string;
  integrationType: string;
  id: number;
  onSuccess: () => void;
  onClose: () => void;
};

const mapStateToProps = (state: RootReduxState, props: OAuthWindowComponentOwnProps) => ({
  status: state.getIn(["Auth", props.selectedShop, props.integrationType, props.id, "status"]) as
    | string
    | undefined,
  token: state.getIn(["Auth", props.selectedShop, props.integrationType, props.id, "token"]) as
    | string
    | undefined,
  success: state.getIn(["Auth", props.selectedShop, props.integrationType, props.id, "success"]) as
    | boolean
    | undefined,
  loading: state.getIn(["Auth", props.selectedShop, props.integrationType, props.id, "loading"]) as
    | boolean
    | undefined,
  error: state.getIn(["Auth", props.selectedShop, props.integrationType, props.id, "error"]) as
    | unknown
    | undefined,
  redirectUrl: state.getIn([
    "Auth",
    props.selectedShop,
    props.integrationType,
    props.id,
    "redirectUrl"
  ]) as string | undefined
});
const matchDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      checkStatusAction,
      updateIntegrationAction
    },
    dispatch
  );
const connector = connect(mapStateToProps, matchDispatchToProps);

type OAuthWindowComponentProps = OAuthWindowComponentOwnProps & ConnectedProps<typeof connector>;

function OAuthWindowComponent(props: OAuthWindowComponentProps) {
  const [checkInterval, setCheckInterval] = useState<number | undefined>(undefined);
  const [windowHandle, setWindowHandle] = useState<Window | null>(null);

  useEffect(() => {
    if (props.status === "accepted") {
      props.updateIntegrationAction(props.integrationType, props.selectedShop, props.id);
      window.clearInterval(checkInterval);
      setCheckInterval(undefined);
      props.onSuccess();
    } else if (props.status !== "pending") {
      if (checkInterval) {
        window.clearInterval(checkInterval);
        windowHandle?.close();
        props.onClose();
        setCheckInterval(undefined);
        setWindowHandle(null);
      }
    }
  }, [props.status]);

  useEffect(() => {
    if (props.success && props.redirectUrl) {
      openOAuthWindow();
    }
  }, [props.success, props.redirectUrl]);

  const openOAuthWindow = () => {
    const windowHandle = window.open(
      props.redirectUrl,
      "targetWindow",
      `toolbar=no,location=no,status=no,menubar=yes,scrollbars=yes,resizable=yes,width=1000,height=750`
    );

    const checkInterval = window.setInterval(() => {
      if (props.token) {
        props.checkStatusAction(props.integrationType, props.selectedShop, props.token, props.id);
      }
      if (windowHandle?.closed) {
        window.clearInterval(checkInterval);
        props.onClose();
      }
    }, 1000);

    setCheckInterval(checkInterval);
    setWindowHandle(windowHandle);
  };

  return null;
}

export const OAuthWindow = connector(OAuthWindowComponent);
